import React, { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { NumericFormat } from "react-number-format";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, label, id, type, error, required, ...props }, ref) => (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="mb-1.5 cursor-pointer text-[15px] font-normal text-system-disabled"
        >
          {label}
          {required && <span className="text-system-disabled">*</span>}
        </label>
      )}
      <input
        type={type}
        id={id}
        className={cn(
          "flex h-[2.625rem] w-full rounded-lg border bg-system-graphite px-4 py-3",
          "text-base text-system-disabled placeholder:text-system-titanium",
          "focus:outline-none focus:ring-0",
          error
            ? "border-system-error focus:border-system-error"
            : "border-[#61646C66] focus:border-system-primary",
          className
        )}
        ref={ref}
        {...props}
      />
      {error && <p className="mt-1 text-[13px] text-system-error">{error}</p>}
    </div>
  )
);

TextInput.displayName = "TextInput";

export default TextInput;

interface AmountInputProps extends Omit<TextInputProps, "onChange" | "value" | "error"> {
  value?: string;
  onChange: (_value: string) => void;
  error?: string;
  helperText?: string;
}

export const AmountInput = forwardRef<HTMLInputElement, AmountInputProps>(function AmountInput(
  { value = "", onChange, type: _type, ...props },
  ref
) {
  return (
    <NumericFormat<TextInputProps>
      customInput={TextInput}
      value={value}
      onValueChange={values => onChange(values.value)}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      allowNegative={false}
      getInputRef={ref}
      type="text"
      {...props}
      defaultValue={0}
    />
  );
});
